var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "my-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    dark: "dark",
                    dense: "dense",
                    block: "block"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/vouchers/create")
                    }
                  }
                },
                [_c("span", [_vm._v("new")])]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "1" } },
            [
              _c("export-excel", {
                attrs: {
                  "cost-centers": _vm.costCenterIndexList,
                  "revenue-sources": _vm.revenueSourceIndexList
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.voucherList,
          headers: _vm.headers,
          "single-expand": "single-expand",
          "items-per-page": _vm.itemsPerPage,
          page: _vm.page,
          "server-items-length": _vm.voucherGetCount,
          loading: _vm.voucherGetting,
          "sort-by": _vm.sortBy,
          dense: "dense",
          "sort-desc": _vm.sortDesc
        },
        on: {
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "body.prepend",
            fn: function() {
              return [
                _vm.showTableTop
                  ? _c("tr", [
                      _c(
                        "td",
                        { attrs: { colspan: _vm.headers.length } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "my-1",
                                  attrs: { lg: "3", cols: "12" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      placeholder:
                                        "Voucher Details Keywords...",
                                      "append-icon": "mdi-magnify",
                                      "hide-details": "hide-details",
                                      outlined: "outlined",
                                      dense: "dense",
                                      clearable: _vm.voucherDetailKeyword
                                    },
                                    model: {
                                      value: _vm.voucherDetailKeyword,
                                      callback: function($$v) {
                                        _vm.voucherDetailKeyword = $$v
                                      },
                                      expression: "voucherDetailKeyword"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "header.id",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Voucher No")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(_vm._b({}, "v-icon", attrs, false), on),
                            [_vm._v("mdi-filter")]
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("base-search-combobox", {
                            model: {
                              value: _vm.voucherNoFilter,
                              callback: function($$v) {
                                _vm.voucherNoFilter = $$v
                              },
                              expression: "voucherNoFilter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _c(
                  "v-icon",
                  {
                    attrs: { color: _vm.showTableTop && "purple" },
                    on: {
                      click: function($event) {
                        _vm.showTableTop = !_vm.showTableTop
                      }
                    }
                  },
                  [_vm._v("mdi-magnify")]
                )
              ]
            },
            proxy: true
          },
          {
            key: "header.date",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Date")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(_vm._b({}, "v-icon", attrs, false), on),
                            [_vm._v("mdi-filter")]
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "no-gutters" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", lg: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "From",
                                      dense: "dense",
                                      "hide-details": "hide-details",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.dateFrom,
                                      callback: function($$v) {
                                        _vm.dateFrom = $$v
                                      },
                                      expression: "dateFrom"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", lg: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "To",
                                      dense: "dense",
                                      "hide-details": "hide-details",
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.dateTo,
                                      callback: function($$v) {
                                        _vm.dateTo = $$v
                                      },
                                      expression: "dateTo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "header.created_by",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Requestor")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { text: "text", small: "small" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-filter")])],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("base-search-combobox", {
                            model: {
                              value: _vm.requestorFilter,
                              callback: function($$v) {
                                _vm.requestorFilter = $$v
                              },
                              expression: "requestorFilter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "header.pay_to",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Pay to")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { text: "text", small: "small" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-filter")])],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("base-search-combobox", {
                            model: {
                              value: _vm.payToFilter,
                              callback: function($$v) {
                                _vm.payToFilter = $$v
                              },
                              expression: "payToFilter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "header.approved_rejected_by",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [
                  _vm._v("Approve / Reject")
                ]),
                _c(
                  "base-tooltip",
                  {
                    attrs: {
                      text: "text",
                      "x-small": "x-small",
                      color: _vm.showSelfApprovedRejected
                        ? "purple"
                        : "blue-grey darken-2",
                      tooltip: _vm.showSelfApprovedRejected
                        ? "Show everything"
                        : "Show only your aproved or rejected",
                      bottom: "bottom"
                    },
                    on: {
                      click: function($event) {
                        _vm.showSelfApprovedRejected = !_vm.showSelfApprovedRejected
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("mdi-filter")])],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "header.paid_by",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Paid by")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { text: "text", small: "small" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-filter")])],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "search",
                              "append-icon": "mdi-magnify",
                              multiple: "multiple",
                              "small-chips": "small-chips",
                              items: _vm.revenueSourceIndexList,
                              "item-value": "id",
                              "item-text": "code",
                              clearable: "clearable",
                              filter: _vm.autocompleteFilter
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "mr-2 primary--text" },
                                      [_vm._v(_vm._s(item.code))]
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "blue-grey--text" },
                                      [_vm._v(_vm._s(item.description))]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.paidByFilter,
                              callback: function($$v) {
                                _vm.paidByFilter = $$v
                              },
                              expression: "paidByFilter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "header.cost_center_id",
            fn: function() {
              return [
                _c("span", { staticClass: "mr-1" }, [_vm._v("Cost Center")]),
                _c("base-menu-popover-component", {
                  attrs: {
                    color: "blue-grey darken-3",
                    title: "Filter",
                    icon: "mdi-filter",
                    "close-on-content-click": false,
                    "nudge-width": 200,
                    "offset-x": "offset-x"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { text: "text", small: "small" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-filter")])],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "search",
                              "append-icon": "mdi-magnify",
                              multiple: "multiple",
                              "small-chips": "small-chips",
                              items: _vm.costCenterIndexList,
                              "item-value": "id",
                              "item-text": "code",
                              clearable: "clearable",
                              filter: _vm.autocompleteFilter
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function({ item }) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "mr-2 primary--text" },
                                      [_vm._v(_vm._s(item.code))]
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "blue-grey--text" },
                                      [_vm._v(_vm._s(item.description))]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.costCenterFilter,
                              callback: function($$v) {
                                _vm.costCenterFilter = $$v
                              },
                              expression: "costCenterFilter"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                })
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "info",
                            "x-small": "x-small",
                            dense: "dense",
                            text: "text"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openInfoDialog(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-information-outline")])],
                        1
                      ),
                      _c("span", [_vm._v(_vm._s(item.voucher_no))])
                    ],
                    1
                  ),
                  _c("td", [_vm._v(_vm._s(item.cost_center.code))]),
                  _c("td", [_vm._v(_vm._s(item.pay_to.name))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(item.created_by ? item.created_by.name : null)
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(item.date.dateFormat()))]),
                  _c("td", [_vm._v(_vm._s(item.paid_by.code))]),
                  _c(
                    "td",
                    {
                      staticClass: "text-uppercase",
                      class: _vm.approvedRejectedColor(item.status)
                    },
                    [_vm._v(" " + _vm._s(item.status.description) + " ")]
                  ),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(_vm.paidAmount(item.transactions).phpFormat())
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      !item.approved_rejected_by && _vm.allowedForApproval
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                text: "text",
                                small: "small",
                                dense: "dense",
                                loading: _vm.approveVoucherPosting
                              },
                              on: {
                                click: function($event) {
                                  return _vm.approveVoucher(item.id)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Approve")])]
                          )
                        : _vm._e(),
                      !item.approved_rejected_by && _vm.allowedForApproval
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "error",
                                text: "text",
                                small: "small",
                                dense: "dense",
                                loading: _vm.rejectVoucherPosting
                              },
                              on: {
                                click: function($event) {
                                  return _vm.rejectVoucher(item.id)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Reject")])]
                          )
                        : _c(
                            "span",
                            { class: _vm.approvedRejectedColor(item.status) },
                            [
                              _vm._v(
                                _vm._s(
                                  item.approved_rejected_by
                                    ? item.approved_rejected_by.name
                                    : null
                                )
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "text-right" },
                    [
                      "AP" === item.voucher_status_id
                        ? _c("base-tooltip", {
                            attrs: {
                              bottom: "bottom",
                              color: "green",
                              "no-btn": "no-btn",
                              tooltip: "COMPLETE VOUCHER"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ on, loading, isLoading }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            attrs: { color: "green" },
                                            on: {
                                              click: function($event) {
                                                return _vm.completeVoucher(
                                                  item.id,
                                                  loading,
                                                  isLoading
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v("mdi-check")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _vm._e(),
                      ["NW", "RJ"].includes(item.voucher_status_id)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "bottom",
                                color: "yellow darken-2"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: {
                                                color: "yellow darken-2"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    name: "vouchers.edit",
                                                    params: {
                                                      voucherId: item.id
                                                    }
                                                  })
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-pencil")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("edit")])]
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "vouchers.receipt-attachments",
                                params: { voucherId: item.id }
                              })
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "blue" } }, [
                            _vm._v("mdi-paperclip")
                          ])
                        ],
                        1
                      ),
                      item.approved_rejected_by &&
                      item.voucher_status_id !== "RJ"
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: {
                                color: "primary",
                                bottom: "bottom",
                                dark: "dark"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openVoucherChequeDialog(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-checkbook")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("Transactions")])]
                          )
                        : _vm._e(),
                      !["NW", "RJ"].includes(item.voucher_status_id)
                        ? _c("base-tooltip", {
                            attrs: {
                              color: "red",
                              dark: "dark",
                              bottom: "bottom",
                              tooltip: "Print PDF",
                              "no-btn": "no-btn"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ on, loading, isLoading }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            attrs: { color: "red" },
                                            on: {
                                              click: function($event) {
                                                return _vm.printPdf(
                                                  item.id,
                                                  loading,
                                                  isLoading
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v("mdi-note-text")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _vm._e(),
                      item.approved_rejected_by &&
                      item.voucher_status_id !== "RJ"
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "bottom",
                                color: "green",
                                dark: "dark"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: { color: "green" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    name:
                                                      "vouchers.petty-cash.manage",
                                                    params: {
                                                      voucherId: item.id
                                                    }
                                                  })
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-note-text")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("Petty Cash Voucher")])]
                          )
                        : _vm._e(),
                      _c(
                        "v-icon",
                        {
                          class: isExpanded ? "is-expanded" : "",
                          attrs: { color: "blue-grey darken-3" },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_vm._v("mdi-chevron-down")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "6" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: "purple",
                            dark: "dark",
                            dense: "dense",
                            flat: "flat"
                          }
                        },
                        [_c("span", [_vm._v("Details")])]
                      ),
                      _c("v-simple-table", {
                        attrs: { dense: "dense" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-center",
                                          attrs: { width: "100" }
                                        },
                                        [_vm._v("Acct")]
                                      ),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v("Desc.")
                                      ]),
                                      _c("th", [_vm._v("Reason")]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v("Amnt")
                                      ])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(item.details, function(item) {
                                        return _c("tr", { key: item.id }, [
                                          _c(
                                            "td",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.account_code.account_code
                                                )
                                              )
                                            ]
                                          ),
                                          _c("td", {
                                            staticClass: "text-left",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.hightLightKeyword(
                                                  item.account_code.description
                                                )
                                              )
                                            }
                                          }),
                                          _c("td", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.hightLightKeyword(
                                                  item.reason
                                                )
                                              )
                                            }
                                          }),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  (item.amount || 0).phpFormat()
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      }),
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-left",
                                            attrs: { colspan: "3" }
                                          },
                                          [_vm._v("Total")]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .totalAmount(item.details)
                                                  .phpFormat()
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: "green",
                            dark: "dark",
                            dense: "dense",
                            flat: "flat"
                          }
                        },
                        [_c("span", [_vm._v("Acct Codes")])]
                      ),
                      _c("v-simple-table", {
                        attrs: { dense: "dense" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Acct")]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v("Dis. Amnt")
                                      ]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v("Amnt")
                                      ])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(item.account_codes, function(
                                        item
                                      ) {
                                        return _c("tr", { key: item.id }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.account_code.account_code
                                              )
                                            )
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  (
                                                    item.disbursed_amount || 0
                                                  ).phpFormat()
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(item.amount.phpFormat())
                                              )
                                            ]
                                          )
                                        ])
                                      }),
                                      item.revolving_fund
                                        ? _c("tr", [
                                            _c("td", [_vm._v("--.--")]),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      (
                                                        item.revolving_fund
                                                          .disbursed_amount || 0
                                                      ).phpFormat()
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c("td")
                                          ])
                                        : _vm._e(),
                                      _c("tr", [
                                        _c("th", [_vm._v("Total")]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  _vm.totalAmount(
                                                    item.account_codes
                                                  ) <
                                                  _vm.totalDisbursedAmount(
                                                    item.account_codes,
                                                    item.revolving_fund
                                                  )
                                                    ? "red--text"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .totalDisbursedAmount(
                                                        item.account_codes,
                                                        item.revolving_fund
                                                      )
                                                      .phpFormat()
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .totalAmount(
                                                    item.account_codes
                                                  )
                                                  .phpFormat()
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c("voucher-transaction", {
        attrs: { voucher: _vm.voucher },
        model: {
          value: _vm.voucherChequeDialog,
          callback: function($$v) {
            _vm.voucherChequeDialog = $$v
          },
          expression: "voucherChequeDialog"
        }
      }),
      _c("voucher-info", {
        attrs: {
          data: _vm.voucher,
          approving: _vm.approveVoucherPosting,
          rejecting: _vm.rejectVoucherPosting
        },
        on: { approve: _vm.approveVoucher, reject: _vm.rejectVoucher },
        model: {
          value: _vm.showInfo,
          callback: function($$v) {
            _vm.showInfo = $$v
          },
          expression: "showInfo"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }